import { render, staticRenderFns } from "./LessonsModal.vue?vue&type=template&id=55075ffc&scoped=true&"
import script from "./LessonsModal.vue?vue&type=script&lang=js&"
export * from "./LessonsModal.vue?vue&type=script&lang=js&"
import style0 from "./LessonsModal.vue?vue&type=style&index=0&id=55075ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55075ffc",
  null
  
)

export default component.exports